import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { MapPin, Navigation } from 'lucide-react';

export default function LocationSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  const { t } = useLanguage();

  return (
    <section id="location" data-testid="location-section" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0B1120]">
      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <motion.div initial={{ opacity: 0, x: -30 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.7 }} className="md:col-span-4">
            <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-bold mb-4 font-['Outfit']">{t('location.label')}</p>
            <h2 className="text-3xl sm:text-4xl font-light text-[#F8FAFC] font-['Cormorant_Garamond'] tracking-tight mb-6">{t('location.title')}</h2>
            <div className="w-16 h-px bg-[#D4AF37] mb-6" />
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-[#F8FAFC] font-['Outfit'] text-sm font-medium">{t('location.address')}</p>
                  <p className="text-[#94A3B8] font-['Outfit'] text-sm">{t('location.area')}</p>
                  <p className="text-[#94A3B8] font-['Outfit'] text-sm">{t('location.state')}</p>
                </div>
              </div>
              <a href="https://www.google.com/maps?q=33.7905526,75.2432304" target="_blank" rel="noopener noreferrer" data-testid="get-directions-btn" className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#FCE69C] transition-colors font-['Outfit'] text-sm mt-4">
                <Navigation className="w-4 h-4" /> {t('location.directions')}
              </a>
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.7, delay: 0.2 }} className="md:col-span-8">
            <div className="rounded-lg overflow-hidden border border-white/10 shadow-2xl shadow-black/30">
              <iframe data-testid="google-map-embed" src="https://www.google.com/maps?q=33.7905526,75.2432304&hl=en&z=15&output=embed" width="100%" height="400" style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg) brightness(0.9) contrast(1.1)' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Khan Complex Location" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
